import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const SimulationActorContextTypename =
  "SimulationActorContext" as const;

export const SimulationActorContextFragment = graphql(`
  fragment SimulationActorContextFields on SimulationActorContext {
    __typename
    validationJobId
    source
  }
`);

interface Props {
  data: FragmentOf<typeof SimulationActorContextFragment>;
}

export function SimulationActorContext({ data }: Props) {
  const p = readFragment(SimulationActorContextFragment, data);
  return (
    <ActorContextRow>
      simulation · {p.source} (job{" "}
      {p.validationJobId ? truncateId(p.validationJobId) : "(no job id)"})
    </ActorContextRow>
  );
}
